export const getProductionItemIssueList = state => {
    return state.list
}

export const getProductionItemIssueDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/productionItemIssue/getters.js